export default class DateUtility {
    private static months = {
        full: [
            'Январь',
            'Февраль',
            'Март',
            'Апрель',
            'Май',
            'Июнь',
            'Июль',
            'Август',
            'Сентябрь',
            'Октябрь',
            'Ноябрь',
            'Декабрь'
        ]
    }

    public static getFullMonthName(month: number): string {
        return this.months.full[month];
    }

    public static getTimeZoneMap(): { [key: string]: string } {
        return {
            "-11": "Pacific/Pago_Pago", // American Samoa Time
            "-10": "Pacific/Honolulu", // Hawaii Standard Time
            "-9": "America/Anchorage", // Alaska Time
            "-8": "America/Los_Angeles", // Pacific Time (US & Canada)
            "-7": "America/Denver", // Mountain Time (US & Canada)
            "-6": "America/Chicago", // Central Time (US & Canada)
            "-5": "America/New_York", // Eastern Time (US & Canada)
            "-4": "America/Caracas", // Venezuela Time
            "-3": "America/Argentina/Buenos_Aires", // Argentina Time
            "-2": "America/Noronha", // Fernando de Noronha Time
            "-1": "Atlantic/Azores", // Azores Standard Time
            "00": "Europe/London", // Greenwich Mean Time
            "+1": "Europe/Berlin", // Central European Time
            "+2": "Europe/Helsinki", // Eastern European Time
            "+3": "Europe/Moscow", // Moscow Time
            "+4": "Asia/Dubai", // Gulf Standard Time
            "+5": "Asia/Karachi", // Pakistan Standard Time
            "+6": "Asia/Dhaka", // Bangladesh Standard Time
            "+7": "Asia/Bangkok", // Indochina Time
            "+8": "Asia/Singapore", // Singapore Standard Time
            "+9": "Asia/Tokyo", // Japan Standard Time
            "+10": "Australia/Brisbane", // Australian Eastern Time
            "+11": "Pacific/Guadalcanal", // Solomon Islands Time
            "+12": "Pacific/Fiji", // New Zealand Standard Time
            "+13": "Pacific/Tongatapu", // Tonga Standard Time
            "+14": "Pacific/Kiritimati" // Line Islands Time
        }
    }

    public static hasTimeZone(timeZone: string): boolean {
        const timeZoneMap = this.getTimeZoneMap();
        for (const key in timeZoneMap) {
            if (timeZoneMap[key] === timeZone) {
                return true;
            }
        }
        return false;
    }

    public static getTimeZoneOffset(timeZone: string): string {
        const timeZoneMap = this.getTimeZoneMap();
        for (const key in timeZoneMap) {
            if (timeZoneMap[key] === timeZone) {
                return key;
            }
        }
        return "+3";
    }
}
